import { getError } from "@remi/error";
import { remiLogger } from "@remi/logging";

interface AblyIdentityDivergenceProps {
  cachedPersonId: string;
  tokenClientId: string | undefined;
  cachedIdentityWasImposter: boolean;
  refreshIdentity: () => Promise<void>;
}

export const handleAblyIdentityDivergence = ({
  cachedPersonId,
  tokenClientId,
  cachedIdentityWasImposter,
  refreshIdentity,
}: AblyIdentityDivergenceProps): boolean => {
  if (!tokenClientId || tokenClientId === cachedPersonId) {
    return false;
  }

  // Must stay free of throwing calls: the caller runs this after callback(null, token) has
  // already succeeded, so a throw here would re-enter authCallback's catch and deny that token.

  // Person.id is unbounded cardinality — only the low-cardinality flag belongs in attributes.
  remiLogger.captureCounterMetric("ably.auth.client-id-mismatch", 1, {
    attributes: { cachedIdentityWasImposter: String(cachedIdentityWasImposter) },
  });
  remiLogger.debug("Ably token identity diverged from cached profile", {
    cachedPersonId,
    tokenPersonId: tokenClientId,
  });
  refreshIdentity().catch((error: unknown) => {
    remiLogger.debug("Ably identity refresh failed", {
      cachedPersonId,
      tokenPersonId: tokenClientId,
      error: getError(error).message,
    });
  });

  return true;
};
